import { useTranslation } from "react-i18next";

export const StepFinished = () => {
	const { t } = useTranslation();

	return (
		<div className="row space-t">
			<div className="col-md-12">
				<h3>{t("finishedTitle")}</h3>
				<p>{t("finishedText1")}</p>
				<p>
					{t("finishedText2")}
					<br />
					{t("finishedText3")}
				</p>
			</div>
		</div>
	);
};
